import React from "react";
import { getUserDocumentRef } from '../../firestorter'
import { observer } from 'mobx-react'

const DisplayName = observer(class DisplayName extends React.Component {
    constructor() {
        super()
        this.state = {
            displayName: 'טוען...'
        }
    }
    componentDidMount() {
        const self = this
        getUserDocumentRef(this.props.uid).then(res => {
            const userData = res.data()
            if (userData && userData.displayName) {
                self.setState({ displayName: userData.displayName })
            }
        })
    }
    render() {
        return (
            <div>{this.state.displayName}</div>
        )
    }
})

export default DisplayName
